import React from 'react';
import './styles.scss';

import { connect } from 'react-redux';

import Input from '@components/Input';
import { setReinforcementWidth, setReinforcementHeight, setReinforcementDepth } from '@reducers/options/reinforcement/actions';
import { setGroundWidth, setGroundHeight, setGroundDepth } from '@reducers/options/ground/actions';

import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';

const DimensionsConcreteMember = props => (
  <div className="calculation base-plate">
    <section className="list-type">
      <div className="form-check justify-content-between align-items-center pr-1 ReinforcementParameters__numbers">
        <Input
          className="form-check-label mt-2"
          prefix="Wa ="
          postfix={unitLabel(props.distanceUnit)}
          id="Wa"
          type="number"
          minValue={0}
          value={unitTransform(+props.ground.width).from(defaultUnits.DISTANCE).to(props.distanceUnit)}
          onUpdate={value => {
            props.setWa(unitTransform(+value, false).from(props.distanceUnit).to(defaultUnits.DISTANCE));
          }}
        />

        <Input
          className="form-check-label mt-2"
          id="Wb"
          prefix="Wb ="
          postfix={unitLabel(props.distanceUnit)}
          type="number"
          minValue={0}
          disabled={!props.reinforcement.width.active}
          value={unitTransform(+props.reinforcement.width.value).from(defaultUnits.DISTANCE).to(props.distanceUnit)}
          onUpdate={value => {
            props.setWb(unitTransform(+value, false).from(props.distanceUnit).to(defaultUnits.DISTANCE));
          }}
        />
      </div>

      <div className="form-check justify-content-between align-items-center pr-1 ReinforcementParameters__numbers">
        <Input
          className="form-check-label mt-2"
          prefix="Ha ="
          postfix={unitLabel(props.distanceUnit)}
          id="Ha"
          type="number"
          minValue={0}
          value={unitTransform(+props.ground.height).from(defaultUnits.DISTANCE).to(props.distanceUnit)}
          onUpdate={value => {
            props.setHa(unitTransform(+value, false).from(props.distanceUnit).to(defaultUnits.DISTANCE));
          }}
        />

        <Input
          className="form-check-label mt-2"
          prefix="Hb ="
          postfix={unitLabel(props.distanceUnit)}
          id="Hb"
          type="number"
          minValue={0}
          disabled={!props.reinforcement.height.active}
          value={unitTransform(+props.reinforcement.height.value).from(defaultUnits.DISTANCE).to(props.distanceUnit)}
          onUpdate={value => {
            props.setHb(unitTransform(+value, false).from(props.distanceUnit).to(defaultUnits.DISTANCE));
          }}
        />
      </div>

      <div className="form-check justify-content-between align-items-center pr-1 ReinforcementParameters__numbers">
        <Input
          className="form-check-label mt-2"
          prefix="La ="
          postfix={unitLabel(props.distanceUnit)}
          id="La"
          type="number"
          minValue={0}
          value={unitTransform(+props.ground.depth).from(defaultUnits.DISTANCE).to(props.distanceUnit)}
          onUpdate={value => {
            props.setLa(unitTransform(+value, false).from(props.distanceUnit).to(defaultUnits.DISTANCE));
          }}
        />

        <Input
          className="form-check-label mt-2"
          prefix="Lb ="
          postfix={unitLabel(props.distanceUnit)}
          id="Lb"
          type="number"
          minValue={0}
          disabled={props.modelType !== 3 || props.modelType !== 5}
          value={unitTransform(+props.reinforcement.depth.value).from(defaultUnits.DISTANCE).to(props.distanceUnit)}
          onUpdate={value => {
            props.setLb(unitTransform(+value, false).from(props.distanceUnit).to(defaultUnits.DISTANCE));
          }}
        />
      </div>
    </section>
  </div>
);

const mapState = state => ({
  reinforcement: state.options.reinforcement,
  ground: state.options.ground,
  modelType: state.modelType,

  distanceUnit: state.main.units.distance
});

const mapDispatch = dispatch => ({
  setWb: value => dispatch(setReinforcementWidth({value: parseFloat(value)})),
  setHb: value => dispatch(setReinforcementHeight({value: parseFloat(value)})),
  setLb: value => dispatch(setReinforcementDepth({value: parseFloat(value)})),

  setWa: value => dispatch(setGroundWidth(parseFloat(value))),
  setHa: value => dispatch(setGroundHeight(parseFloat(value))),
  setLa: value => dispatch(setGroundDepth(parseFloat(value)))
});

export default connect(mapState, mapDispatch)(DimensionsConcreteMember);



// WEBPACK FOOTER //
// ./src/views/Dimension/Rebar/DimensionsConcreteMember.js